import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAdminForm = async (id?: number) => {
	if (!id) return Promise.reject("No form id");

	const url = `/observations/admin/forms/${id}/`;

	const response = await cmsClient.get<IAdminObservationForm>(url);
	return response.data;
};

interface Options {
	enabled?: boolean;
}

const useAdminForm = (id?: number, options: Options = { enabled: true }) => {
	const { enabled } = options;

	const query = useQuery(["adminForm", id], () => fetchAdminForm(id), {
		enabled
	});

	return query;
};

export default useAdminForm;
